var eventMap = {
  cacheRoot:"https://media.hubhawaii.com/events/cache/"+ELAJAX.calendarID+"/",
  markers:[],
  filterCategoryNames:[],

  filterCategoryCount:{},
  load:function(holderID,config={}){
    this.holderID = holderID;
    this.config = {
      timestamp:new Date().getTime(),
      showPOI:false,
      ...config
    };
    this.config.timestamp = parseInt(this.config.timestamp);
    this.holder = document.getElementById(holderID);

    this.dateHeader = document.getElementById('mapDateHeader');

    this.loadMap();
    this.loadDate(this.config.timestamp);
    this.layout();
  },
  layout:function(){
    var mapHeader = document.getElementById("mapHeader");
    if(!mapHeader) return;
    var headerOffset = window.innerWidth < 768 ? 64 : 44;
    var unstickScroll = false;

    window.addEventListener("scrollOLD",()=>{

      var mapHeaderBounds = mapHeader.getBoundingClientRect();

      if(mapHeaderBounds.top <= headerOffset && !mapHeader.classList.contains("stick")){
        mapHeader.classList.add("stick");
        mapHeader.style.top = headerOffset + "px";
        this.spacer = document.createElement("div");
        this.spacer.style.display = "block";
        this.spacer.classList.add("spacer");
        if(window.innerWidth < 768){
          this.spacer.style.height = "158px";
          setTimeout(()=>{
            this.spacer.style.height = "92px";
          },100);
        }
        else{
          mapHeaderBounds = mapHeader.getBoundingClientRect();
          this.spacer.style.height = mapHeaderBounds.height + "px";
        }



        mapHeader.parentNode.insertBefore(this.spacer,mapHeader);
        unstickScroll = window.scrollY;
      }
      else if(unstickScroll && window.scrollY <= unstickScroll){
        unstickScroll = false;
        mapHeader.classList.remove("stick");
        mapHeader.style.top = "auto";
        if(this.spacer){
          this.spacer.remove();
        }
      }
    });
  },
  showPOI:function(){
    if(document.getElementById("showPOI").checked){
      this.config.showPOI = true;

    }
    else{
      this.config.showPOI = false;
    }
    this.map.setOptions({styles:this.getMapStyle()});
  },
  getMapStyle:function(){
    return [
      {
        featureType:"poi",
        elementType:"labels.icon",
        stylers:[
          {visibility:this.config.showPOI ? "on" : "off"}
        ]
      },
      {
        featureType:"transit",
        stylers:[
          {visibility:"off"}
        ]
      },
      {
        featureType:"administrative.country",
        stylers:[
          {visibility:"off"}
        ]
      },
      {
        featureType:"administrative.land_parcel",
        stylers:[
          {visibility:"off"}
        ]
      }
    ];
  },
  loadMap:function(){
    this.map = new google.maps.Map(this.holder, {
      center: { lat: this.config.latitude, lng: this.config.longitude },
      zoom: this.config.zoom,
      clickableIcons:false,
      styles:this.getMapStyle()
    });

    this.infoWindow = new google.maps.InfoWindow({
      content:'',
      disableAutoPan:true
    });
  },
  loadDate:async function(timestamp){

    if(typeof timestamp !== "number"){
      if(timestamp.indexOf("-") > 0){

        var [month,date,year] = timestamp.split("-");
        var dateObj = new Date(year,month-1,date);
        timestamp = dateObj.getTime();
      }
    }
    this.timestamp = timestamp;

    if(this.dateHeader){
      this.dateHeader.innerHTML = this.dateHeader.getAttribute("data-append") + moment.utc(this.timestamp).format("dddd, MMMM D, YYYY");
    }

    this.loadEvents();

  },
  loadEvents:async function(){
    this.date = new Date();
    this.date.setTime(this.timestamp);
    this.dateString = (this.date.getUTCMonth()+1)+"-"+this.date.getUTCDate()+"-"+this.date.getUTCFullYear();

    var events_onetime = await this.getCache(this.dateString);

    var repeat_day = "repeat_day_"+this.date.getUTCDay();
    var events_repeat_day = await this.getCache(repeat_day);

    var repeat_date = "repeat_date_"+this.date.getUTCDate();
    var events_repeat_date = await this.getCache(repeat_date);

    var weekNum = Math.ceil(this.date.getUTCDate()/7);
    var repeat_day_week = "repeat_day_week_"+this.date.getUTCDay()+":"+weekNum;
    var events_repeat_day_week = await this.getCache(repeat_day_week);


    var data = [...events_onetime,...events_repeat_day,...events_repeat_date,...events_repeat_day_week];
    elLoader.hide();

    this.map.setCenter({lat:this.config.latitude,lng:this.config.longitude});
    this.map.setZoom(this.config.zoom);

    this.displayEvents(data);


  },
  clearMarkers:function(){
    for(let i =0;i<this.markers.length;i++){
      this.markers[i].setMap(null);
      console.log(this.markers);
    }
  },
  displayEvents:function(data){
    var events = data.filter(e=>{
      if(e.latitude && e.longitude){
        return true;
      }
      return false;
    });

    var eventGroups = [];

    events.forEach(e=>{
      let key = e.latitude + ","+e.longitude;
      if(!eventGroups[key]){
        eventGroups[key] = [];
      }
      eventGroups[key].push(e);
    });

    if(this.markerCluster){
      this.markerCluster.clearMarkers();

    }
    this.filterCategoryCount = {};
    this.markers = Object.keys(eventGroups).map(key=>{
      let e = eventGroups[key];
      let [latitude,longitude] = key.split(",");
      console.log(latitude,longitude);

      let label = "";
      let groupCount = 0;
      let hasFeatured = false;
      let featuredImage = ELAJAX.images + "mapFeaturedIcon.png";
      let iconImage = ELAJAX.images + "mapIcon.png";
      e.forEach((edata,index)=>{
        let hasCategory = this.filterCategoryNames.find(c=>{

          return edata.category.indexOf(c) >= 0;
        });

        if(edata.featured){
          hasFeatured = true;
          
        }

        edata.category.split(",").forEach(c=>{
          if(!this.filterCategoryCount[c]){
            this.filterCategoryCount[c] = 0;
          }
          this.filterCategoryCount[c]++;
        });


        if(this.filterCategoryNames.length == 0 || hasCategory){
          label += this.eventLabel(edata,index);
          groupCount++;
        }
      });

      if(groupCount >  0){
        let position = {lat:parseFloat(latitude),lng:parseFloat(longitude)};

        if(hasFeatured === true){
          const icon = {
            url: featuredImage, // url
            scaledSize: new google.maps.Size(50, 50), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(25, 50), // anchor
          };
          var marker = new google.maps.Marker({
            position:position,
            label:'',
            icon:icon
          });
          

        }
        else{
          const icon = {
            url: iconImage, // url
            scaledSize: new google.maps.Size(50, 50), // scaled size
            origin: new google.maps.Point(0,0), // origin
            anchor: new google.maps.Point(25, 50), // anchor
            
          };
          var marker = new google.maps.Marker({
            position:position,
            label:'',
            icon:icon
          });
  
        }
        


        marker.addListener("click",()=>{
          this.infoWindow.setContent(label+"<a href='#' style='padding-top:3px;border-top:1px solid #ececec;text-align:center;display:block;' onClick='eventMap.closeInfo(event);'>Close</a>");
          
          this.infoWindow.open(this.map,marker);
          this.map.setCenter({lat:parseFloat(latitude),lng:parseFloat(longitude)});


        });
        return marker;
      }
      else{
        return false;
      }
    });


    this.markers = this.markers.filter(m=>{
      return m !== false;
    });

    this.updateFilterCount();
    var markerStyle = this.getGoogleClusterInlineSvg('green');
    this.markerCluster = new markerClusterer.MarkerClusterer({
      markers:this.markers,
      map:this.map,
      styles:[

        {
          url:markerStyle,
          width:50,
          height:50,
          textSize:14,
          textColor:"#fff"
        }

      ]});
  },
  closeInfo:function(event){
    event.preventDefault();
    this.infoWindow.close();
  },
  getGoogleClusterInlineSvg:function (color) {
    var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.7"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.5"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/></g></defs><g fill="' + color + '"><circle r="42"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');
    return ('data:image/svg+xml;base64,' + encoded);
  },
  eventLabel:function(event,index){
    var labelHTML = "<div class='eventMapLabel "+(index > 0 ? "lineTop" : "")+"' onClick=\"eventPopup.showEvent('"+event.eventHash+"');\">";
    labelHTML += "<b>"+event.title+"</b>";
    labelHTML += this.displayTimes(event.dates);
    labelHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Chevron Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M184 112l144 144-144 144"/></svg>';
    labelHTML += "</div>";
    return labelHTML;
  },
  expandEvent:function(eventHash){
    alert(eventHash);
  },
  updateFilterCount:function(){
    var countElements = document.querySelectorAll("[data-filterCount]");
    countElements.forEach(e=>{
      var category = e.getAttribute("data-filterCount");
      if(this.filterCategoryCount[category] > 0){
        e.querySelector(".count").innerHTML = "("+this.filterCategoryCount[category]+")";
        e.style.display = "block";
      }
      else{
        e.style.display = "none";
      }

    });

    var filterCount = this.filterCategoryNames.length;

    var filterButtons = document.querySelectorAll(".filterCount");
    filterButtons.forEach(b=>{
      if(filterCount > 0){
        b.style.display = "block";
        b.innerHTML = filterCount;
        return;
      }
      b.style.display = "none";
    });
  },
  applyFilters:function(){

    var categories = document.querySelectorAll(".filterCategory:checked");
    this.filterCategoryNames = [];
    categories.forEach(c=>{
      this.filterCategoryNames.push(c.value);
    });


    //this.filterCounts();
    this.loadEvents();


  },
  clearFilters:function(){
    this.filterCategoryNames = [];
    this.loadEvents();
  },
  displayTimes:function(dates){
    var date = dates.filter(d=>{
      var weekNum = Math.ceil(this.date.getUTCDate()/7);
      if(d.repeat_day && d.repeat_day == this.date.getUTCDay()){
        return true;
      }
      else if(d.repeat_date && d.repeat_date == this.date.getUTCDate()){
        return true;
      }
      else if(d.repeat_day_week && d.repeat_day_week == this.date.getUTCDay() + ":" + weekNum){
        return true;
      }
      return d.date == this.dateString;
    });
    var returnVal = "";
    date.forEach((d,index)=>{
      if(index > 0){
        returnVal += " &middot; ";
      }
      returnVal += d.timeString;
    });
    return returnVal;
  },
  getCache:async function(cacheKey){
    var result = await new Promise((resolve,reject)=>{
      fetch(this.cacheRoot+cacheKey+".cache?v="+new Date().getTime())
      .then(res=>res.json())
      .then(data=>{
        resolve(data);
      }).catch(e=>{
        resolve([]);
      });


    });

    return result;

  }

}
